/**
 * KPI 维度服务
 */

import axios from 'axios';
import { KPIDimension } from './types';
import { getListResponse, API_BASE } from './utils';

export const kpiDimensionService = {
    list: async (params?: { is_active?: boolean }): Promise<KPIDimension[]> => {
        const response = await axios.get(`${API_BASE}/kpi-dimensions/`, { params });
        return getListResponse(response.data);
    },

    get: async (id: number): Promise<KPIDimension> => {
        const response = await axios.get(`${API_BASE}/kpi-dimensions/${id}/`);
        return response.data;
    },

    create: async (data: Partial<KPIDimension>): Promise<KPIDimension> => {
        const response = await axios.post(`${API_BASE}/kpi-dimensions/`, data);
        return response.data;
    },

    update: async (id: number, data: Partial<KPIDimension>): Promise<KPIDimension> => {
        const response = await axios.patch(`${API_BASE}/kpi-dimensions/${id}/`, data);
        return response.data;
    },

    delete: async (id: number): Promise<void> => {
        await axios.delete(`${API_BASE}/kpi-dimensions/${id}/`);
    },
};
